<template>
  <!-- クローズ時のメッセージ画面 -->
  <div class="close-dialog">
    <div class="-step" v-if="color.register_icon_type == 1 && step == 1">
      <img class="image-step" src="@/assets/lp/logo.png"/>
      <br><br>
      こちらの企業のロボとの会話を<br>
      保存しますか？<br>
      （登録は１分で簡単）<br>
      <br>
      メール<input class="input" maxlength="254" v-model="email"/>
      <br><br><br>
      <div class="button-menu">
        <button class="button is-primary" @click="createPreAccount()" :disabled="checkEmail">登録する</button>
        <button class="button" @click="close(1)">閉じる</button>
      </div>
    </div>
    <div class="-step" v-if="color.register_icon_type == 1 && step == 2">
      <img class="image-step" src="@/assets/lp/logo.png"/>
      <br><br>
      ご登録ありがとうございます。<br>
      Eメールを送付しましたので、ご確認の程宜しくお願い致します。<br>
      <hr>
      <button class="button is-primary" @click="close(1)">閉じる</button>
    </div>
    <div class="-step" v-if="color.register_icon_type == 0 && step == 1">
      <img class="image-step" src="@/assets/lp/logo.png"/>
      <br><br>
      会話いただきありがとうございました！<br>
      閉じるボタンを押すと終了いたします。<br>
      <hr>
      <button class="button is-primary" @click="close(1)">閉じる</button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    step: {
      type: Number,
      required: true,
    },
    color: {
      type: Object,
      required: true
    },
  },
  data () {
    return {
      email: null
    }
  },
  created () {
    this.email = null
  },
  computed: {
    checkEmail () {
      return this.email || this.email.indexOf('@') == -1
    }
  },
  methods: {
    createPreAccount () {
      this.$emit('createPreAccount', this.email)
    },
    close (num) {
      this.$emit('close', num)
    }
  }
}
</script>

<style lang="scss" scoped>
.close-dialog {
  width: calc(100% - 10px);
  height: calc(100% - 40px);
  padding: 16px;
  border-radius: 8px;
  position: absolute;
  background: #f8f8f8ee;
  z-index: 9999999;
  .-step {
    padding: 8px; padding-top: 32px;
    .image-step {
      width: 128px; height: 128px; object-fit: contain;
    }
    input {
      background: white;
    }
    .button-menu {
      display: flex; justify-content: center;
      button {
        margin: 5px; width:100px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/ChatWidgetDialog/organisms/CloseDialogMessage.vue